import { render, staticRenderFns } from "./BaseSelect2.vue?vue&type=template&id=e64ec078&scoped=true&"
import script from "./BaseSelect2.vue?vue&type=script&lang=js&"
export * from "./BaseSelect2.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelect2.vue?vue&type=style&index=0&id=e64ec078&prod&lang=css&"
import style1 from "./BaseSelect2.vue?vue&type=style&index=1&id=e64ec078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64ec078",
  null
  
)

export default component.exports